import React, { useEffect } from 'react';
import {
  BellOutlined,
  MenuOutlined,
} from '@ant-design/icons';
import { Badge, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import PageRoutes from "../PageRoutes";
import AppMenu from "../menu/index";

const MobileLayout = ({ viewModel }) => {
  const navigate = useNavigate();
  const {
    user,
    accountMenu,
    showMenu,
    openMenu,
    closeMenu,
    colorBgContainer,
    notificationUnreadCount,
  } = viewModel;

  useEffect(() => {
    const handleOpenMenu = () => {
      openMenu();
    };

    window.addEventListener('open-mobile-app-menu', handleOpenMenu);

    return () => {
      window.removeEventListener('open-mobile-app-menu', handleOpenMenu);
    };
  }, [openMenu]);

  return (
    <>
      <AppMenu
        variant="mobile"
        showMenu={showMenu}
        onCloseMenu={closeMenu}
        accountMenu={accountMenu}
        workspaceName={user.work_space.name}
        userFirstName={user.first_name}
      />

      <div
        style={{
          height: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          background: '#f5f5f5',
        }}
      >
        <div
          style={{
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            minHeight: 44,
            padding: 'calc(env(safe-area-inset-top, 0px) + 4px) 8px 4px',
            background: colorBgContainer,
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          <Button type="link" onClick={openMenu} style={{ paddingInline: 8, height: 32 }}>
            <MenuOutlined />
          </Button>
          <b style={{ lineHeight: 1.2 }}>{user.work_space.name}</b>
          <div style={{ marginLeft: 'auto' }}>
            <Button
              type='link'
              onClick={() => navigate('/notifications?view=inbox')}
              style={{ paddingInline: 8, height: 40 }}
              aria-label='Mở thông báo'
            >
              <Badge count={notificationUnreadCount > 99 ? '99+' : notificationUnreadCount} size='small' color='#1677ff' offset={[-2, 2]}>
                <BellOutlined style={{ fontSize: 20 }} />
              </Badge>
            </Button>
          </div>
        </div>

        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
            padding: 8,
            paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 8px)',
          }}
        >
          <PageRoutes></PageRoutes>
        </div>
      </div>
    </>
  );
};

export default MobileLayout;
